





import Vue from 'vue';
import SkillProvider from '@/api/SkillProvider';
import SpriteIcon from '@/components/util/SpriteIcon.vue';
import IIconInfo from '@/models/util/IIconInfo';

export default Vue.extend({
    name: 'SkillRef',
    components: {
        SpriteIcon,
    },
    props: {
        skillId: {
            type: Number as () => number,
            required: true,
        },
    },
    data() {
        return {
            skillName: '',
            skillIcon: null as IIconInfo | null,
        };
    },
    watch: {
        skillId() {
            this.load();
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.skillName = '';
            this.skillIcon = null;
            try {
                const skill = await SkillProvider.getSkill(this.skillId);
                this.skillName = skill.name.message;
                // Mirrors SkillView.vue's hasSkillIcon fallback: index 0 means "no icon set" —
                // prefer the buff/debuff icon over showing nothing.
                if (skill.skillIcon.index === 0) {
                    if (skill.buffIcon && skill.buffIcon.index >= 0) {
                        this.skillIcon = skill.buffIcon;
                    } else if (skill.debuffIcon && skill.debuffIcon.index >= 0) {
                        this.skillIcon = skill.debuffIcon;
                    } else {
                        this.skillIcon = skill.skillIcon;
                    }
                } else {
                    this.skillIcon = skill.skillIcon;
                }
            } catch (e) {
                // keep "Skill {id}" fallback
            }
        },
    },
});
